import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { USER } from 'sh-www/models/user';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';
import { blockingLocationAssign } from 'sh-www/utils/window';
import { setUserId, trackEventAsync } from 'sh-www/utils/datalayer';

const CLASS_NAME = 'GLM-brand-signup';

const INSTAGRAM_QUOTE_AUTHOR_IMG_SRC = 'https://res.cloudinary.com/ddsqycvoq/image/upload/t_profile128,f_auto,q_auto/www/avatar/stefanie-h.jpg';

class BrandSignupController extends Controller {
  @service('commands/stashed-data-commands') stashedDataCommandService;
  @service('commands/user-commands') userCommandService;
  @service('error-tracker') errorTracker;
  @service auth;
  @service media;
  @service router;
  @service session;

  storedDirectAssignmentDraft = null;
  storedAssignmentFreelancer = null;

  get className() {
    return CLASS_NAME;
  }

  get isLoading() {
    return this.loadDirectAssignmentFreelancer.isRunning;
  }

  get authorImageSrc() {
    return INSTAGRAM_QUOTE_AUTHOR_IMG_SRC;
  }

  @task
  *loadDirectAssignmentFreelancer(directAssignmentDraftUUID) {
    try {
      const storedDirectAssignmentDraft = yield this.stashedDataCommandService.getByUUID(directAssignmentDraftUUID);
      const storedAssignmentFreelancer = yield this.userCommandService.getUser(storedDirectAssignmentDraft.sellerId, ['image', 'location']);
      this.setProperties({ storedDirectAssignmentDraft, storedAssignmentFreelancer });
    } catch (error) {
      this.errorTracker.error(error, this, `loadDirectAssignmentFreelancer failed for uuid ${directAssignmentDraftUUID}}.`);
    }
  }

  @task
  *createUser(email, password) {
    const newUser = {
      email,
      password,
      type: USER.TYPES.BUYER,
    };

    yield this.auth.createUser(newUser);

    if (this.storedDirectAssignmentDraft) {
      yield this.stashedDataCommandService.assignUserToStashedData(this.storedDirectAssignmentDraft.uuid, this.session.currentUser.id);
    }

    setUserId(this, this.session.currentUser.id);

    yield trackEventAsync(this, 'sign_up');
    yield blockingLocationAssign('/start');
  }

  @task
  *onGoogleSSO(credential) {
    try {
      yield this.auth.signupGoogleJwt(credential, USER.TYPES.BUYER);

      if (this.storedDirectAssignmentDraft) {
        yield this.stashedDataCommandService.assignUserToStashedData(this.storedDirectAssignmentDraft.uuid, this.session.currentUser.id);
      }
    } catch (e) {
      this.errorTracker.warn('Google authentication failed', this, e);
      handleErrorResponseWithModal(this, e);
      throw e;
    }

    setUserId(this, this.session.currentUser.id);

    yield trackEventAsync(this, 'sign_up');
    yield blockingLocationAssign('/start');
  }
}

export default BrandSignupController;
